import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import Services from './components/Services';
import Appointment from './components/Appointment';
import Contact from './components/Contact';
import Admin from './components/Admin';
import AdminAuth from './components/AdminAuth';
import WalkIn from './components/WalkIn';
import { VacationProvider } from './context/VacationContext';
import { BookingProvider } from './context/BookingContext';
import './App.css';

function App() {
  return (
    <VacationProvider>
      <BookingProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/appointment" element={<Appointment />} />
              <Route path="/walkin" element={<WalkIn />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/AdminAuth" element={<AdminAuth open={true} onClose={() => {}} />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </BookingProvider>
    </VacationProvider>
  );
}

export default App;
